export default __webpack_public_path__ + "static/media/art-pro-red-banner-1.28291afa.jpg";